// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-f"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 5H10C9.44772 5 9 5.44772 9 6V12M9 12H16M9 12V19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersFIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-f',
    ref,
    icon: element,
  },
));

LettersFIcon.displayName = 'LettersFIcon';

export default LettersFIcon;
